'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// /Users/manskow/Local Sites/topphndball-v-53/app/public/wp-content/themes/nth-5.3/node_modules/function-bind/index.js
// module id = 4
// module chunks = 0